export const apiRenteon = {
	syncRenteon: async () => {
		const { data } = await apiCommon<{ data: any }>('sync-renteon', { method: 'POST' })
		console.log(data)
	},

	getNeccessaryAddons: async () => {
		const data = await apiCommon<any[]>('renteon/all-additions', { method: 'GET' })
		return data as unknown as any[]
	},
}
